import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';
import { GenericIdbaService } from './generic-idba-service.service';
import { GenericIdbaRequestModel } from '../models/generic-idba-request-model';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends GenericIdbaService {
  private filter: any;
  private reportApi: string;
  private reportProcedure: string;
  public title:string;
  public matDialogConfig: MatDialogConfig;
  public listReport:boolean;
  public treeReport:boolean;
  public tableStyle: any;

  constructor(http: HttpClient) {
    super(http);
  }

  setFilter(filter: any) {
    this.filter = filter;
  }

  getFilter() {
    return this.filter;
  }

  setFilterDialog<T, D = any>(filterComponent: ComponentType<T>, matDialogConfig: MatDialogConfig<D>){
    this.matDialogConfig = matDialogConfig;
    this.filterComponent = filterComponent;
  }

  setReportApi(reportApi: string, reportProcedure: string = "pi-executar") {
    this.reportApi = reportApi;
    this.reportProcedure = reportProcedure;
  }

  executeReport() {
    const request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = this.reportApi;
    request.procedure = this.reportProcedure;
    request.parameters = this.filter;

    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, {
      observe: 'response',
    });
  }

  getReportInfo() {
    const request: GenericIdbaRequestModel = new GenericIdbaRequestModel();
    request.program = "utils/report/report.p";
    request.procedure = "pi-get-report-info";

    return this.httpClient.post<any>(this.configService.getApiUrl('integrateUrl'), request, {
      observe: 'response',
    });
  }
}